import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Dialog zur Anzeige des Upload-Ergebnisses (Erfolg/Fehlschlag).
 */
function UploadResultDialog({ open, onClose, result }) {
  const { t } = useTranslation();
  if (!open || !result) return null;

  const isSuccess = result.type === 'success';
  const title = isSuccess ? t('dialog.upload_result.success') : t('dialog.upload_result.failed');

  return (
    <div className="edit-overlay" onClick={onClose}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>{title}</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        <div className="edit-content">
          <p style={{
            fontSize: '1rem',
            color: isSuccess ? '#10b981' : '#ef4444',
            lineHeight: '1.6',
            fontWeight: '600'
          }}>
            {isSuccess ? '✅' : '❌'} {result.message}
          </p>
        </div>
        <div className="edit-actions">
          <button className="btn btn-primary" onClick={onClose}>
            {t('dialog.ok')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UploadResultDialog;
